var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79289 7.79289C6.18342 7.40237 6.81658 7.40237 7.2071 7.79289L10.5 11.0858L13.7929 7.79289C14.1834 7.40237 14.8166 7.40237 15.2071 7.79289C15.5976 8.18342 15.5976 8.81658 15.2071 9.20711L11.2071 13.2071C10.8166 13.5976 10.1834 13.5976 9.79289 13.2071L5.79289 9.20711C5.40237 8.81658 5.40237 8.18342 5.79289 7.79289Z",
    fill: "currentColor"
  })));
};
export default SvgDown;